import { render, staticRenderFns } from "./resultPoint.vue?vue&type=template&id=6cd73119&scoped=true"
import script from "./resultPoint.vue?vue&type=script&lang=js"
export * from "./resultPoint.vue?vue&type=script&lang=js"
import style0 from "./resultPoint.vue?vue&type=style&index=0&id=6cd73119&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd73119",
  null
  
)

export default component.exports